import { render } from "./Offering.vue?vue&type=template&id=5aac354e&scoped=true"
import script from "./Offering.vue?vue&type=script&lang=js"
export * from "./Offering.vue?vue&type=script&lang=js"

import "./Offering.vue?vue&type=style&index=0&id=5aac354e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5aac354e"

export default script